export default {
  BILLING_DETAILS: `Facturation`,
  BILLINGDETAILS: {
    LABEL: `Billing`,
    DESCRIPTION: ``
  },
  BILLINGID: {
    LABEL: `Identifiant de facturation`,
    PLACEHOLDER: `Entrez un identifiant`,
    DESCRIPTION: `Ce champ peut contenir un numéro de PO, un numéro de contrat ou tout autre identifiant lié à la facturation.`
  },
  NONBILLABLE: {
    LABEL: `Non-facturable`,
    DESCRIPTION: ``
  },
  MEMO1: {
    LABEL: `Memo 1`,
    PLACEHOLDER: `Entrez une note d'au maximum 30 caractères`,
    DESCRIPTION: ``
  },
  MEMO2: {
    LABEL: `Memo 2`,
    PLACEHOLDER: `Entrez une note d'au maximum 30 caractères`,
    DESCRIPTION: ``
  },
  MEMO3: {
    LABEL: `Memo 3`,
    PLACEHOLDER: `Entrez une note d'au maximum 30 caractères`,
    DESCRIPTION: ``
  }
}
